import React, { createContext, useContext, useState, useMemo } from 'react';
import { node, bool } from 'prop-types';

import { isIOS } from '../utils/promo-presentation-utils';

export const PromoPresentationContext = createContext();
export const usePromoPresentation = () => useContext(PromoPresentationContext);

export const PromoPresentationProvider = ({ isBatchLoading, children }) => {
  const [isDrawerOpen, setIsDrawerOpen] = useState(false);
  const [isFirstProductPodVisible, setIsFirstProductPodVisible] = useState(true);
  const [promoListRef, setPromoListRef] = useState();
  const isAppleMobileDevice = isIOS();

  const contextValue = useMemo(() => {
    return {
      isDrawerOpen,
      setIsDrawerOpen,
      isFirstProductPodVisible,
      setIsFirstProductPodVisible,
      promoListRef,
      setPromoListRef,
      isAppleMobileDevice,
      isBatchLoading,
    };
  }, [isDrawerOpen, isFirstProductPodVisible, promoListRef, isAppleMobileDevice, isBatchLoading]);

  return (
    <PromoPresentationContext.Provider value={contextValue}>
      { children }
    </PromoPresentationContext.Provider>
  );
};

PromoPresentationProvider.propTypes = {
  children: node.isRequired,
  isBatchLoading: bool.isRequired,
};
